import request from '@/utils/request'
const route_name = '/reducer/getreducerseriesnamelist2'
const route_specs = '/reducer/getspecifications'
const route_level = '/reducer/getlevel'
const route_ratio = '/reducer/getreductionratio'
const route_motorSize = '/reducer/getusablemotorsize'

const route_size = '/reducer/getreducersize'
const route_size_2 = '/reducer/getonereducersize'

const route_size_list = '/reducer/getreducertypelist'
const route_size_one_list = '/reducer/getonereducertype'

const route_reducersize = '/reducer/getallinfo'
export function getName() {
  return request.get(route_name, {
    headers: {
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function getSpecs(data) {
  return request.get(route_specs,{
    headers: {
      'Content-Type': 'application/json'
    },
    params: {
      reducer_series_name:data.reducer_series_name
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

export function getLevel(data) {
  return request.get(route_level, {
    headers: {
      'Content-Type': 'application/json'
    },
    params:{
      specifications:data.specifications
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

// 通过系列名 规格获取减速机型号列表
export function getSizeList(data) {
  return request.get(route_size_list, {
    headers: {
      'Content-Type': 'application/json'
    },
    params:{
      reducer_level:data.reducer_level,
      specifications:data.specifications
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

// 通过系列名 规格 减速比获取减速机型号列表
export function getSizeList2(data) {
  return request.get(route_size_one_list, {
    headers: {
      'Content-Type': 'application/json'
    },
    params:{
      specifications:data.specifications,
      reduction_ratio:data.reduction_ratio,
      power_size:data.motor_formula
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}

// 通过规格 级数 获取减速比
export function getRatio(data) {
  return request.get(route_ratio, {
    headers: {
      'Content-Type': 'application/json'
    },
    params:{
      specifications:data.specifications
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 通过规格 减速比 获取马达尺寸
export function getMotorSize(data) {
  return request.get(route_motorSize, {
    headers:{
      'Content-Type': 'application/json'
    },
    params:{
      specifications:data.specifications,
      reduction_ratio:data.reduction_ratio
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}
// 通过减速机规格、减速比获取减速尺寸详情
export function getinfobyreducersize(data) {
  return request.post(route_reducersize, data ,{
    headers:{
      'Content-Type': 'application/json'
    }
  }).then((response) => {
    return Promise.resolve(response.data)
  })
}



// WEBPACK FOOTER //
// ./src/store/electric_param.js